/* global $, document */

const menu = document.querySelectorAll('.mobile-menu')[0];
const btnOpen = document.querySelectorAll('[data-action="open-mobile-menu"]')[0];
const btnClose = document.querySelectorAll('[data-action="close-mobile-menu"]')[0];

function registerEvents() {
	btnOpen.addEventListener('click', () => {
		openMenu();
	});

	btnClose.addEventListener('click', () => {
		closeMenu();
	});
}

function openMenu() {
	menu.classList.add('is--active');
}

function closeMenu() {
	menu.classList.remove('is--active');
}

function init() {
	if (menu && btnOpen && btnClose) {
		registerEvents();
	}
}

export default {
	init
};
